import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import Iconify from '../common/iconify.component';

const ListMatchOptions = ({ options, fontSize }) => (
  <TableContainer>
    <Table size="small">
      <TableBody>
        {options.map((option) => (
          <TableRow key={option.optionId}>
            <TableCell sx={{ padding: 0.5, fontSize }}>
              {option.optionText}
            </TableCell>
            <TableCell sx={{ padding: 0.5, fontSize }}>
              <Iconify icon="mynaui:arrow-right" />
            </TableCell>
            <TableCell sx={{ padding: 0.5, fontSize }}>
              {option.mappedOptionText}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

ListMatchOptions.propTypes = {
  options: PropTypes.array.isRequired,
  fontSize: PropTypes.number,
};
ListMatchOptions.defaultProps = {
  fontSize: 14,
};

export default ListMatchOptions;
